module.exports = __webpack_public_path__ + "img/iron-throne-2.ac2e3354.png";